document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.querySelector('.product__media-wrapper');
  if (!wrapper) return;

  // Video's zitten in dit thema verpakt in <deferred-media>, dat pas een
  // echte <video>-tag krijgt zodra de slide actief wordt of iemand op play klikt.
  // Daarom zoeken we op <deferred-media> zelf, niet op <video>.
  var videoItem = wrapper.querySelector(
    '.product__media-item deferred-media, .product__media-item model-viewer, .product__media-item product-model'
  );
  if (!videoItem) return; // geen video bij dit product, geen knop

  var slide = videoItem.closest('.product__media-item') || videoItem;

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'gallery-video-cta';
  btn.innerHTML = '▶ Video afspelen';

  wrapper.insertAdjacentElement('afterend', btn);

  btn.addEventListener('click', function () {
    slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });

    setTimeout(function () {
      if (typeof videoItem.loadContent === 'function') {
        videoItem.loadContent();
      } else {
        var poster = slide.querySelector('.deferred-media__poster');
        if (poster) poster.click();
      }
    }, 500);
  });
});
document.addEventListener('DOMContentLoaded', function () {
  // Alleen mobiel nodig, op desktop staat alles al naast elkaar in het grid.
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  var list = document.querySelector('.product__media-list');
  if (!list) return;

  var items = list.querySelectorAll(':scope > li:not([data-clone-slide])');
  if (items.length < 2) return;

  var clone = items[0].cloneNode(true);
  clone.removeAttribute('id');
  clone.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
  clone.setAttribute('aria-hidden', 'true');
  clone.setAttribute('tabindex', '-1');
  clone.setAttribute('data-clone-slide', 'true');
  list.appendChild(clone);

  var resetting = false;

  function maybeReset() {
    if (resetting) return;
    var maxScroll = list.scrollWidth - list.clientWidth;

    if (list.scrollLeft >= maxScroll - 4) {
      resetting = true;
      list.style.scrollSnapType = 'none';
      list.scrollLeft = 0;
      requestAnimationFrame(function () {
        list.style.scrollSnapType = '';
        resetting = false;
      });
    }
  }

  list.addEventListener('scroll', function () {
    window.requestAnimationFrame(maybeReset);
  }, { passive: true });
});
document.addEventListener('DOMContentLoaded', function () {
  var MARKER = '@shoplook';
  var target = document.querySelector('[id*="shop_the_look"]');
  if (!target) return; // geen shop-the-look sectie op deze pagina

  document.querySelectorAll('.product__media-item').forEach(function (item) {
    var img = item.querySelector('img[alt*="' + MARKER + '"]');
    if (!img) return;

    // Marker weg uit de zichtbare/voorleesbare alt-tekst
    img.alt = img.alt.replace(MARKER, '').trim();

    // Visueel label, net als bij Omoda
    item.style.position = 'relative';
    var badge = document.createElement('span');
    badge.textContent = 'BEKIJK DE LOOK';
    badge.className = 'llf-look-badge';
    item.appendChild(badge);

    // Vóór de zoom-klik van het thema onderscheppen
    item.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, true); // capture-fase: gaat eerder af dan de zoom van het thema
  });
});